import * as React from "react";
import DataSource from "../lib/DataSource";
import {
  Alert,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Space,
  message,
} from "antd";
import { FetchWithAuth } from "digimaker-ui/util";
import { Link } from "react-router-dom";
import { util } from "../lib/Util";
import SubjectResultAdd from "./Add";
import { useState } from "react";
import { exportToExcel } from "../lib/exportExcel";

const { Option } = Select;

export default class ResultList extends React.Component<
  {},
  {
    courses: any;
    limitation: any;
    resultFetched: boolean;
    subjects: any;
    filter: any;
    loading?: boolean;
    resultList: any;
    add: boolean;
    addedTo: any;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      courses: "",
      limitation: "",
      resultFetched: false,
      subjects: "",
      filter: { subject: 0, stage: 1 },
      resultList: "",
      add: false,
      addedTo: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    FetchWithAuth("content/list/course?sortby=c.name%20asc&limit=0&offset=0")
      .then((data) => {
        this.setState({
          courses: data.data.list,
          filter: {
            ...this.state.filter,
            course: data.data.list[0].id,
            intake: util.currentIntake(),
          },
        });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });

    FetchWithAuth("icd/access/get_intake")
      .then((data) => {
        if (data && data.data.length > 0) {
          this.setState({ limitation: data.data });
        }
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });

    FetchWithAuth("content/list/subject?sortby=c.name%20asc&limit=0&offset=0")
      .then((data) => {
        this.setState({ subjects: data.data.list });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  async fetchResult() {
    let filter = this.state.filter;
    let course = filter.course;
    let intake = filter.intake;
    let stage = filter.stage;
    let subject = filter.subject;
    this.setState({ loading: true });
    let res = await FetchWithAuth(
      "content/list/student?field.course=" +
        course +
        "&field.intake=" +
        intake +
        "&field.stage=" +
        stage +
        "&limit=0&offset=0",
    );
    let data = await res.data.list;
    let ids: Array<any> = [];
    for (let item of data.list) {
      ids.push(item.id);
    }
    if (ids.length == 0) {
      this.setState({ resultList: [] });
    } else {
      let res = await FetchWithAuth(
        "icd/subject/result/list?student=" +
          ids.join(",") +
          "&subject=" +
          subject,
      );
      let data = await res.data.list;
      data.sort((a, b) => {
        return parseInt(a.student_no) - parseInt(b.student_no);
      });
      this.setState({ resultList: data });
    }
    this.setState({ loading: false, resultFetched: true });
  }

  getFilteredSubjets() {
    const result = this.state.subjects.filter(
      (subject) =>
        (subject.stage_year == this.state.filter.stage ||
          !this.state.filter.stage) &&
        subject.course == this.state.filter.course,
    );
    return result;
  }

  batchAdd() {
    this.setState({ add: true, addedTo: this.state.resultList });
  }

  addResult(item: any) {
    this.setState({ add: true, addedTo: [item] });
  }

  fetchSubjectDownloadData(subjectId) {
    if (subjectId <= 0) {
      return;
    }

    let filter = this.state.filter;

    return DataSource.loadSubjectResultData(subjectId, filter).then((list) => {
      list.sort((a, b) => parseInt(a.student_no) - parseInt(b.student_no));
      let courseId = this.state.filter.course;
      let course = this.state.courses.filter((course) => course.id == courseId);

      if (course.length == 0) {
        course = "";
      } else {
        course = course[0].name;
      }

      let subject = this.state.subjects.filter(
        (subject) => subject.id == subjectId,
      );

      if (subject.length == 0) {
        subject = "";
      } else {
        subject = subject[0].name;
      }

      return {
        course: course,
        courseId: courseId,
        subject: subject,
        subjectId: subjectId,
        intake: this.state.filter.intake,
        list: list,
      };
    });
  }

  buildDownloadData(subjectId) {
    for (const item of this.state.resultList) {
    }
  }

  buildSubjectDownloadData(subjectId) {
    let results = this.fetchSubjectDownloadData(subjectId);
    let subjectDetail = DataSource.loadSubjectData(subjectId);

    return Promise.all([results, subjectDetail])
      .then((data) => {
        data[0].subjectDetail = data[1];
        return data[0];
      })
      .then((data) => {
        data["overall"] = [];
        let dataSet: Array<any> = [];
        // set subject info
        dataSet.push({
          columns: [],
          xSteps: 0,
          ySteps: -1,
          data: [
            ["Subject: " + data.subject],
            ["Class: " + data.course + "-" + data.intake],
          ],
        });

        // set table data
        let result = {
          columns: [
            "Ref. No.",
            "First Name",
            "Surname",
            "Stage year",
            "Phone",
            "Email",
            "Result",
            "Overall",
          ],
          xSteps: 0,
          ySteps: 1,
          data: new Array<any>(),
        };

        for (const student of data.list) {
          dataSet.push([
            student.student_no,
            student.firstname,
            student.lastname,
            student.stage,
            student.telephone,
            student.email,
            util.calculateResult(student.resultList),
            student.score_overall,
          ]);
        }

        data["dataSet"] = dataSet;
        return data;
      });
  }

  calculateSubjectOverAll(record, assessmentMapping, overallIndex) {
    let overall = 0.0;

    Object.entries(assessmentMapping).forEach(([_key, _value]) => {
      if (
        !_key.endsWith("-result") ||
        !_value ||
        !record[parseInt("" + _value, 10)]
      ) {
        return;
      }

      // console.log([_key, _value, record[parseInt(''+_value, 10)]]);

      overall += parseFloat(record[parseInt("" + _value, 10)]);
    });

    record[overallIndex] = overall.toFixed(1);

    return record;
  }

  downloadSubjectResult() {
    if (this.state.filter.subject <= 0) return;
    const result = this.state.resultList.map((student) => ({
      student_no: student.student_no,
      firstname: student.firstname,
      lastname: student.lastname,
      intake: this.state.filter.intake,
      telephone: student.telephone,
      email: student.email,
      result: util.calculateResult(student.results),
    }));
    exportToExcel(
      result,
      [
        { label: "Student No", value: "student_no" },
        { label: "First Name", value: "firstname" },
        { label: "Surname", value: "lastname" },
        { label: "Phone", value: "telephone" },
        { label: "Intake", value: "intake" },
        { label: "Email", value: "email" },
        { label: "Result", value: "result" },
      ],
      "Subject Result",
      "Subject Result",
    );
  }

  subjectResultHiddenExcel() {
    if (this.state.filter.subject > 0) {
      return (
        <Button onClick={() => this.downloadSubjectResult()}>
          Subject Download
        </Button>
      );
    }
    return "";
  }

  downloadOverall() {
    const subjects = this.getFilteredSubjets();
    const result = this.state.resultList.map((item) => {
      const subjectResults = {};
      for (const subject of subjects) {
        const assessments = item.results.filter(
          (i) => i.subject_id == subject.id,
        );
        subjectResults[subject.id] = util.calculateResult(assessments);
      }
      return {
        student_no: item.student_no,
        firstname: item.firstname,
        lastname: item.lastname,
        intake: item.intake,
        email: item.email,
        telephone: item.telephone,
        stage: this.state.filter.stage,
        subjects: subjectResults,
        average: util.getResultsAverage(
          item.results,
          subjects,
          item.stu_course.is_bachelor,
        ),
        overall: item.score_overall,
      };
    });
    const filename = `Overall Result-${this.state.filter.course}-${this.state.filter.intake}`;
    exportToExcel(
      result,
      [
        { label: "Student No", value: "student_no" },
        { label: "First Name", value: "firstname" },
        { label: "Surname", value: "lastname" },
        { label: "Phone", value: "telephone" },
        { label: "Intake", value: "intake" },
        { label: "Email", value: "email" },
        { label: "Stage year", value: "stage" },
        ...subjects.map((item) => ({
          label: item.name,
          value: (row) => row.subjects[item.id],
        })),
        { label: "Average", value: "average" },
        { label: "Overall", value: "overall" },
      ],
      "Overall Result",
      filename,
    );
  }

  delete(e: any, id: any) {
    e.preventDefault();
    Modal.confirm({
      content: <p>Do you confirm to delete?</p>,
      onOk: () => {
        FetchWithAuth("icd/subject/result/delete/" + id)
          .then((data) => {
            Modal.info({
              content: <p>Result is deleted!</p>,
              onOk: () => this.fetchResult(),
            });
          })
          .catch((err) => {
            this.setState(() => {
              throw err;
            });
          });
      },
    });
  }

  canAccessIntakeYear(year, month) {
    if (this.state.limitation) {
      let result = false;
      for (const item of this.state.limitation) {
        if (month + "-" + year == item) {
          result = true;
          break;
        }
      }
      return result;
    } else {
      return true;
    }
  }

  render() {
    let intakeMonths = util.intakeMonths();
    let intakeYears = util.intakeYears();

    let courses = this.state.courses;
    let subjects = this.state.subjects;
    let resultList = this.state.resultList;

    if (!courses || !subjects) {
      return "";
    }

    let subjectID = this.state.filter.subject;

    return (
      <div>
        <div className="main-top">
          <h2>Result list</h2>
        </div>
        <div>
          <h3>Select students</h3>
          <Row className="block">
            <Col span={4}>Course:</Col>
            <Col>
              <Select
                onSelect={(value: any) =>
                  this.setState({
                    filter: { ...this.state.filter, course: value },
                    resultFetched: false,
                  })
                }
                defaultValue={this.state.filter.course}
                style={{ width: "600px" }}
              >
                {this.state.courses.map((item) => (
                  <Option value={item.id}>{item.name}</Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="block">
            <Col span={4}>Intake:</Col>
            {!this.state.limitation && (
              <Col>
                <Select
                  defaultValue={this.state.filter.intake.split("-")[0]}
                  style={{ width: "80px" }}
                  onSelect={(value: any) =>
                    this.setState({
                      filter: {
                        ...this.state.filter,
                        intake:
                          value + "-" + this.state.filter.intake.split("-")[1],
                      },
                      resultFetched: false,
                    })
                  }
                >
                  {intakeMonths.map((v) => (
                    <>
                      <Option value={v}>{v}</Option>
                    </>
                  ))}
                </Select>
                <Select
                  defaultValue={this.state.filter.intake.split("-")[1]}
                  style={{ width: "80px" }}
                  onSelect={(value: any) =>
                    this.setState({
                      filter: {
                        ...this.state.filter,
                        intake:
                          this.state.filter.intake.split("-")[0] + "-" + value,
                      },
                      resultFetched: false,
                    })
                  }
                >
                  {intakeYears.map((v) => (
                    <Option value={v}>{v}</Option>
                  ))}
                </Select>
              </Col>
            )}
            {this.state.limitation && (
              <Col>
                <Select
                  defaultValue={0}
                  style={{ width: "150px" }}
                  onSelect={(value: any) =>
                    this.setState({
                      filter: { ...this.state.filter, intake: value },
                    })
                  }
                >
                  <Option value={0}>Select intake</Option>
                  {this.state.limitation.map((item) => (
                    <Option value={item.intake}>{item.intake}</Option>
                  ))}
                </Select>
              </Col>
            )}
          </Row>
          <Row className="block">
            <Col span={4}>Stage year:</Col>
            <Col>
              <Select
                defaultValue={1}
                style={{ width: "150px" }}
                onSelect={(value: any) =>
                  this.setState({
                    filter: { ...this.state.filter, stage: value },
                    resultFetched: false,
                  })
                }
              >
                {["None", 1, 2, 3, 4].map((year) => (
                  <Option value={year == "None" ? "" : year}>{year}</Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="block">
            <Col span={4}>Subject:</Col>
            {!this.state.limitation && (
              <Col>
                <Select
                  defaultValue={0}
                  style={{ width: "400px" }}
                  onSelect={(value: any) =>
                    this.setState({
                      filter: { ...this.state.filter, subject: value },
                      resultFetched: false,
                    })
                  }
                >
                  <Option value={0}>Select subject</Option>
                  {this.getFilteredSubjets().map((subject: any) => (
                    <Option value={subject.id}>
                      {subject.name} ({subject.credit})
                    </Option>
                  ))}
                </Select>
              </Col>
            )}
            {this.state.limitation && (
              <Col>
                <Select
                  defaultValue={0}
                  style={{ width: "400px" }}
                  onSelect={(value: any) =>
                    this.setState({
                      filter: { ...this.state.filter, subject: value },
                      resultFetched: false,
                    })
                  }
                >
                  <Option value={0}>Select subject</Option>
                  {this.getFilteredSubjets().map((subject: any) => {
                    const exist = this.state.limitation.find(
                      (item) => item.subject === subject.id,
                    );
                    return (
                      <>
                        {exist && (
                          <Option value={subject.id}>
                            {subject.name} ({subject.credit}) {subject.id}
                          </Option>
                        )}
                      </>
                    );
                  })}
                </Select>
              </Col>
            )}
          </Row>
          <Row className="block">
            <Col>
              <Space>
                <Button type="primary" onClick={() => this.fetchResult()}>
                  Fetch result
                </Button>
                {this.state.resultFetched && (
                  <>
                    {subjectID > 0 && <>{this.subjectResultHiddenExcel()}</>}
                    {subjectID === 0 && (
                      <>
                        <Button
                          type="link"
                          onClick={() => this.downloadOverall()}
                        >
                          Overall Download
                        </Button>
                      </>
                    )}
                  </>
                )}
              </Space>
            </Col>
          </Row>
        </div>

        {this.state.loading === true && <div className="loading"></div>}

        {resultList !== "" && this.state.resultFetched && (
          <div className="block">
            {resultList.length == 0 && <Alert message="No student found." />}
            {resultList.length > 0 && (
              <div>
                {subjectID > 0 && (
                  <div className="text-right">
                    <Button type="link" onClick={() => this.batchAdd()}>
                      Batch add results
                    </Button>
                  </div>
                )}
                <div className="right">Total {resultList.length}</div>
                <table className="table">
                  <tbody>
                    <tr>
                      <th>Student No.</th>
                      <th>First name</th>
                      <th>Last name</th>
                      <th>Intake</th>
                      {subjectID > 0 && (
                        <>
                          <th>Assesment results</th>
                          <th>Result</th>
                          <th></th>
                        </>
                      )}
                      {subjectID === 0 && (
                        <>
                          <th>Average</th>
                          <th>Overall</th>
                        </>
                      )}
                    </tr>
                    {resultList.map((item) => (
                      <tr>
                        <td>
                          <Link to={"/subject/result/view/" + item.id}>
                            {item.student_no}
                          </Link>
                        </td>
                        <td>{item.firstname}</td>
                        <td>{item.lastname}</td>
                        <td>{item.intake}</td>
                        {subjectID > 0 && (
                          <>
                            <td>
                              {item.results.map((result) => (
                                <div>
                                  <Row>
                                    <Col span={16}>
                                      {result.subject},
                                      {result.is_exemption == 0 && (
                                        <span>
                                          {result.assessment}: {result.score}
                                        </span>
                                      )}
                                      {result.is_exemption == 1 && (
                                        <span className="exemption">EXE</span>
                                      )}
                                      {result.is_repeat == 1 && (
                                        <span className="repeat">
                                          {result.repeat_no}
                                        </span>
                                      )}
                                    </Col>
                                    <Col span={8}>
                                      {/* <a href="" title="Update"><i className="fa fa-edit"></i></a> &nbsp; */}
                                      <a
                                        href=""
                                        title="Delete"
                                        onClick={(e: any) =>
                                          this.delete(e, result.id)
                                        }
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </td>
                            <td>
                              {util.washResult(
                                util.calculateResult(item.results),
                              )}
                            </td>
                            <td>
                              <Button
                                onClick={() => this.addResult(item)}
                                type="link"
                              >
                                Add result
                              </Button>
                            </td>
                          </>
                        )}
                        {subjectID === 0 && (
                          <>
                            <td>
                              {util.getResultsAverage(
                                item.results,
                                this.getFilteredSubjets(),
                                item.stu_course.is_bachelor,
                              )}
                            </td>
                            <td>
                              <Overall
                                id={item.id}
                                stageYear={item.stage}
                                value={item.score_overall}
                                onUpdated={() => {
                                  this.fetchResult();
                                }}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
                {this.state.add && (
                  <Modal
                    visible={true}
                    footer={false}
                    onCancel={() => this.setState({ add: false })}
                  >
                    <SubjectResultAdd
                      subject={this.state.subjects.find(
                        (item) => item.id == this.state.filter.subject,
                      )}
                      list={this.state.addedTo}
                      onSuccess={() => {
                        this.setState({ add: false });
                        this.fetchResult();
                      }}
                    />
                  </Modal>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const getValue = (v, year) => {
  if (!v) {
    return v;
  }

  let obj = JSON.parse(v);
  return obj[year] || "";
};

export const Overall = (props: { id; value; onUpdated; stageYear }) => {
  const getInitValue = () => {
    return getValue(props.value, props.stageYear);
  };

  const [shown, setShown] = useState(false);
  const [value, setValue] = useState(getInitValue());

  const confirmUpdateOverall = () => {
    let obj = props.value ? JSON.parse(props.value) : {};
    obj[props.stageYear] = value;
    FetchWithAuth("content/update/student/" + props.id, {
      method: "POST",
      body: JSON.stringify({ score_overall: JSON.stringify(obj) }),
    }).then((data) => {
      if (data.data == "1") {
        message.success("Updated");
        props.onUpdated();
      }
    });

    setShown(false);
  };

  return (
    <div className="overall-container">
      <Modal
        onOk={() => confirmUpdateOverall()}
        onCancel={() => setShown(false)}
        title="Update overall"
        visible={shown}
      >
        <Input value={value} onChange={(e) => setValue(e.target.value)} />
      </Modal>
      <span>{getInitValue()}</span> &nbsp;
      <Button onClick={() => setShown(true)}>Update</Button>
    </div>
  );
};
